/* eslint-disable @typescript-eslint/no-explicit-any */

import type { ChangeEvent } from 'react'

export function isHTMLTableCellElement(
  subject: HTMLElement
): subject is HTMLTableCellElement {
  return subject instanceof HTMLTableCellElement
}

export function isHTMLTableRowElement(
  subject: (Node & ParentNode) | null
): subject is HTMLTableRowElement {
  return subject instanceof HTMLTableRowElement
}

export function isHTMLTableSectionElement(
  subject: (Node & ParentNode) | null
): subject is HTMLTableSectionElement {
  return subject instanceof HTMLTableSectionElement
}

export function isHTMLTableElement(
  subject: (Node & ParentNode) | null
): subject is HTMLTableElement {
  return subject instanceof HTMLTableElement
}

export function isHTMLDivElement(
  subject: (Node & ParentNode) | null
): subject is HTMLDivElement {
  return subject instanceof HTMLDivElement
}

export function isInputElementEvent(
  subject: any
): subject is ChangeEvent<HTMLInputElement> {
  return (
    subject &&
    subject.hasOwnProperty('currentTarget') &&
    subject['currentTarget'] instanceof HTMLInputElement
  )
}
